import { ResumeTabsType } from '../../../../../types/ResumeTypes';
import C from '../ViewerMode.module.scss';
import S from './SelfIntroductionViewer.module.scss';
import _ from "lodash";

interface SelfIntroductionViewer {
  selfIntroduction: string;
  resumeTabs: ResumeTabsType;
}

const SelfIntroductionViewer = (props: SelfIntroductionViewer) => {
  const { resumeTabs, selfIntroduction } = props;

  if(selfIntroduction === undefined || _.isEmpty(selfIntroduction)){
    return null;
  }

  return (
    <>
      <section ref={resumeTabs[4].element} className={`${C.viewer_section} wrapper`}>
        <h4 className={`${C.section_title} h4`}>자기소개서</h4>
        {/* 개별 박스 */}
        <article className={`${C.common_box}`}>
          {/* 상세 내용 */}
          <div className={`${C.profile_text_wrap} ${S.self_text_wrap}`}>
            <div className={C.profile_text_line}>
              <div className={C.text_el_wrap}>
                <h4 className="b1">
                  {selfIntroduction}
                </h4>
              </div>
            </div>
          </div>
        </article>
        <hr />
      </section>
    </>
  );
};

export default SelfIntroductionViewer;
